import { render, staticRenderFns } from "./PageFeed.vue?vue&type=template&id=72ffb733&scoped=true&"
import script from "./PageFeed.vue?vue&type=script&lang=ts&"
export * from "./PageFeed.vue?vue&type=script&lang=ts&"
import style0 from "./PageFeed.vue?vue&type=style&index=0&id=72ffb733&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ffb733",
  null
  
)

export default component.exports